import { createFileRoute } from "@tanstack/react-router";
import { RevealStagger } from "@/components/site/Reveal";
import { Section } from "@/components/site/Section";
import { useSiteSection } from "@/hooks/useSiteContent";
import { stats } from "@/content/site";

export const Route = createFileRoute("/sobre")({
  head: () => ({
    meta: [
      { title: "Sobre a Contato Internet — Conexão de verdade" },
      {
        name: "description",
        content:
          "Conheça a Contato Internet: provedor regional de fibra óptica e rádio, com rede própria, equipe local e milhares de clientes conectados.",
      },
      { property: "og:title", content: "Sobre a Contato Internet" },
      {
        property: "og:description",
        content: "Provedor regional de fibra óptica com rede própria e equipe local.",
      },
    ],
  }),
  component: SobrePage,
});

function SobrePage() {
  const about = useSiteSection("about");
  const paragraphs = (about.text ?? "").split(/\n\s*\n/).filter(Boolean);
  const values = (about.values ?? "")
    .split("\n")
    .map((v) => v.trim())
    .filter(Boolean);

  return (
    <>
      <Section reveal eyebrow="Quem somos" title={about.title}>
        <div className="mx-auto max-w-4xl space-y-4">
          {paragraphs.map((p) => (
            <p
              key={p.slice(0, 40)}
              className="text-sm leading-relaxed text-muted-foreground sm:text-base"
            >
              {p}
            </p>
          ))}
        </div>

        <RevealStagger className="mt-12 grid gap-6 md:grid-cols-3" staggerDelay={120}>
          <article className="rounded-3xl border border-border bg-card p-8">
            <h3 className="text-xl">{about.missionTitle}</h3>
            <p className="mt-3 text-sm text-muted-foreground">{about.mission}</p>
          </article>
          <article className="rounded-3xl border border-border bg-card p-8">
            <h3 className="text-xl">{about.visionTitle}</h3>
            <p className="mt-3 text-sm text-muted-foreground">{about.vision}</p>
          </article>
          <article className="rounded-3xl border border-border bg-card p-8">
            <h3 className="text-xl">{about.valuesTitle}</h3>
            <ul className="mt-3 space-y-1.5 text-sm text-muted-foreground">
              {values.map((v) => (
                <li key={v}>• {v}</li>
              ))}
            </ul>
          </article>
        </RevealStagger>
      </Section>

      <Section reveal dark title="A Contato em números">
        <RevealStagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" staggerDelay={100}>
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-3xl border border-brand-sky/25 bg-brand-sky/10 p-7"
            >
              <p className="text-3xl font-extrabold text-brand-yellow">{s.value}</p>
              <p className="mt-1 text-sm text-brand-sky">{s.label}</p>
            </div>
          ))}
        </RevealStagger>
      </Section>
    </>
  );
}
